/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellModelExport, _super);
    function TemplateCellModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ae = null;
        return _this;
    }
    TemplateCellModelExport.prototype.get_ac = function () {
        return "TemplateCell";
    };
    TemplateCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
    };
    TemplateCellModelExport.$t = markType(TemplateCellModelExport, 'TemplateCellModelExport', CellModelExport.$);
    return TemplateCellModelExport;
}(CellModelExport));
export { TemplateCellModelExport };
//# sourceMappingURL=TemplateCellModelExport.js.map
